import { v1HttpClient } from './index.js'
import { HttpMethodEnum, WebSocketClient } from '@ipevo-rd/service-web-utils'
import {
  ChannelHistoriesReq,
  ChannelMp3UrlReq,
  ChannelRatingReq,
  ChannelSummaryReq, ChannelWSReq,
} from './dto/ChannelDTO.js'
import { getAPIUrl } from '../api.js'
import { ApiVersionEnum } from '../enums/ApiVersionEnum.js'

/**
 * Channel API
 */
export const Channel = {
  /**
   * User API
   */
  User: {
    /**
     * Get history of a channel
     * @param params {ChannelHistoriesReq} Parameters
     * @return {Promise<unknown>}
     */
    Histories: (params: ChannelHistoriesReq): Promise<unknown> => v1HttpClient.request({
      url: '/channels/histories',
      method: HttpMethodEnum.GET,
      params,
    }),
    /**
     * MP3 URL for a channel
     * @param params {ChannelMp3UrlReq} Parameters
     * @return {Promise<unknown>}
     */
    Mp3Url: (params: ChannelMp3UrlReq): Promise<unknown> => v1HttpClient.request({
      url: `/channels/stream/${params.id}/${params.language}/${params.gender}/${params.message_id}`,
      method: HttpMethodEnum.GET,
    }),
    /**
     * Summary of a channel
     * @param params {ChannelSummaryReq} Parameters
     * @return {Promise<unknown>}
     */
    Summary: (params: ChannelSummaryReq): Promise<unknown> => v1HttpClient.request({
      url: '/channels/summary',
      method: HttpMethodEnum.GET,
      params,
    }),
    /**
     * Rating a channel
     * @param data {ChannelRatingReq} data
     * @return {Promise<unknown>}
     */
    Rating: (data: ChannelRatingReq): Promise<unknown> => v1HttpClient.request({
      url: `/channels/${data.id}/rating`,
      method: HttpMethodEnum.POST,
      data,
    }),
    /**
     * 連接 Session
     * @param params {ChannelWSReq} 參數
     * @return {Promise<unknown>}
     */
    ConnectChannel: (params: ChannelWSReq): WebSocketClient => new WebSocketClient(`${getAPIUrl(ApiVersionEnum.V1)}/channels/${params.id}/ws?viewer_id=${params.viewer_id}`),
  },
}
